<template>
    <div>
        <role-view :role="roleComponent" />
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import RoleView from "@/components/roles/RoleView.vue";

export default {
    name: "CreateUpdateRole",
    components: {
        RoleView
    },
    data: () => ({
        isLoading: false,
        roleComponent: {
            slug: "",
            name: "",
            description: "",
            permissions: [
                {
                    name: "",
                    slug: ""
                }
            ]
        }
    }),
    computed: { ...mapGetters("control", ["backgroundColor"]) },
    async mounted() {
        const verifyPagePermission =
            this.$ability.verifyPagePermission.bind(this);
        if (!(await verifyPagePermission("role:Get", "/app/roles"))) return;
        const slug = this.$route.params.slug;
        await this.getBaseItem(slug);
    },
    methods: {
        ...mapActions("roles", ["getRoleBySlug"]),
        async getBaseItem(slug) {
            this.isLoading = true;
            this.$loading.show();
            try {
                this.roleComponent = await this.getRoleBySlug({ slug });
                this.isLoading = false;
                this.$loading.hide();
            } catch (error) {
                this.isLoading = false;
                this.$loading.hide();
                this.isLoading = false;
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        }
    }
};
</script>
